<template>
  <div class="text-right">
    <h3 class="text-left">Datos del envío</h3>
    <hr />
    <div class="list-group text-left">
      <form class="row">
        <div class="col-sm-12 col-12 mt-3 pt-2">
          <span class="btn btn-treid btn-block mt-4" @click="handleAutocomplete()">Click aquí para utilizar mi dirección cargada en Sistema Apple</span>
        </div>
        <div class="col-sm-6 col-12 mt-3" v-if="paises.length">
          <label
            :class="
              showRequired &&
              $parent.inputs.shipping.pais.required &&
              !$parent.inputs.shipping.pais.value
                ? 'text-danger'
                : ''
            "
            >País</label
          >
          <select
            class="form-control shadow-sm"
            v-model="$parent.inputs.shipping.pais.value"
            :class="
              showRequired &&
              $parent.inputs.shipping.pais.required &&
              !$parent.inputs.shipping.pais.value
                ? 'border-danger'
                : ''
            "
          >
            <option v-for="pais in paises" :key="pais.iso3" :value="pais.iso3">
              {{ pais.nombre }}
            </option>
          </select>
        </div>

        <div
          class="col-sm-6 col-12 mt-3"
          v-if="$parent.inputs.shipping.pais.value == 'MEX'"
        >
          <label
            :class="
              showRequired &&
              $parent.inputs.shipping.estado.required &&
              !$parent.inputs.shipping.estado.value
                ? 'text-danger'
                : ''
            "
            >Estado</label
          >
          <select
            class="form-control shadow-sm"
            v-model="$parent.inputs.shipping.estado.value"
            :class="
              showRequired &&
              $parent.inputs.shipping.estado.required &&
              !$parent.inputs.shipping.estado.value
                ? 'border-danger'
                : ''
            "
          >
            <option
              v-for="estado in estadosMEX"
              :key="estado.name"
              :value="estado.name"
            >
              {{ estado.name }}
            </option>
          </select>
        </div>
        <div class="col-sm-6 col-12 mt-3" v-else>
          <label
            :class="
              showRequired &&
              $parent.inputs.shipping.estado.required &&
              !$parent.inputs.shipping.estado.value
                ? 'text-danger'
                : ''
            "
            >Estado</label
          >
          <input
            type="text"
            class="form-control shadow-sm"
            v-model="$parent.inputs.shipping.estado.value"
            :class="
              showRequired &&
              $parent.inputs.shipping.estado.required &&
              !$parent.inputs.shipping.estado.value
                ? 'border-danger'
                : ''
            "
          />
        </div>
        <div class="col-sm-6 col-12 mt-3">
          <label
            :class="
              showRequired &&
              $parent.inputs.shipping.colonia.required &&
              !$parent.inputs.shipping.colonia.value
                ? 'text-danger'
                : ''
            "
            >Colonia</label
          >
          <input
            type="text"
            class="form-control shadow-sm"
            v-model="$parent.inputs.shipping.colonia.value"
            :class="
              showRequired &&
              $parent.inputs.shipping.colonia.required &&
              !$parent.inputs.shipping.colonia.value
                ? 'border-danger'
                : ''
            "
          />
        </div>
        <div class="col-sm-6 col-12 mt-3">
          <label
            :class="
              showRequired &&
              $parent.inputs.shipping.ciudad.required &&
              !$parent.inputs.shipping.ciudad.value
                ? 'text-danger'
                : ''
            "
            >Ciudad</label
          >
          <input
            type="text"
            class="form-control shadow-sm"
            v-model="$parent.inputs.shipping.ciudad.value"
            :class="
              showRequired &&
              $parent.inputs.shipping.ciudad.required &&
              !$parent.inputs.shipping.ciudad.value
                ? 'border-danger'
                : ''
            "
          />
        </div>
        <div class="col-sm-6 col-12 mt-3">
          <label
            :class="
              showRequired &&
              $parent.inputs.shipping.calle.required &&
              !$parent.inputs.shipping.calle.value
                ? 'text-danger'
                : ''
            "
            >Calle</label
          >
          <input
            type="text"
            class="form-control shadow-sm"
            v-model="$parent.inputs.shipping.calle.value"
            :class="
              showRequired &&
              $parent.inputs.shipping.calle.required &&
              !$parent.inputs.shipping.calle.value
                ? 'border-danger'
                : ''
            "
          />
        </div>
        <div class="col-sm-6 col-12 mt-3">
          <label
            :class="
              showRequired &&
              $parent.inputs.shipping.numeroExt.required &&
              !$parent.inputs.shipping.numeroExt.value
                ? 'text-danger'
                : ''
            "
            >Número ext.</label
          >
          <input
            type="text"
            class="form-control shadow-sm"
            v-model="$parent.inputs.shipping.numeroExt.value"
            :class="
              showRequired &&
              $parent.inputs.shipping.numeroExt.required &&
              !$parent.inputs.shipping.numeroExt.value
                ? 'border-danger'
                : ''
            "
          />
        </div>
        <div class="col-sm-6 col-12 mt-3">
          <label
            :class="
              showRequired &&
              $parent.inputs.shipping.numeroInt.required &&
              !$parent.inputs.shipping.numeroInt.value
                ? 'text-danger'
                : ''
            "
            >Número int.</label
          >
          <input
            type="text"
            class="form-control shadow-sm"
            v-model="$parent.inputs.shipping.numeroInt.value"
            :class="
              showRequired &&
              $parent.inputs.shipping.numeroInt.required &&
              !$parent.inputs.shipping.numeroInt.value
                ? 'border-danger'
                : ''
            "
          />
        </div>
        <div class="col-sm-6 col-12 mt-3">
          <label
            :class="
              showRequired &&
              $parent.inputs.shipping.codigoPostal.required &&
              !$parent.inputs.shipping.codigoPostal.value
                ? 'text-danger'
                : ''
            "
            >Código postal</label
          >
          <input
            type="text"
            class="form-control shadow-sm"
            v-model="$parent.inputs.shipping.codigoPostal.value"
            :class="
              showRequired &&
              $parent.inputs.shipping.codigoPostal.required &&
              !$parent.inputs.shipping.codigoPostal.value
                ? 'border-danger'
                : ''
            "
          />
        </div>
        <div class="col-sm-6 col-12 mt-3">
          <label
            :class="
              showRequired &&
              $parent.inputs.shipping.telefono.required &&
              !$parent.inputs.shipping.telefono.value
                ? 'text-danger'
                : ''
            "
            >Teléfono</label
          >
          <input
            type="text"
            class="form-control shadow-sm"
            v-model="$parent.inputs.shipping.telefono.value"
            :class="
              showRequired &&
              $parent.inputs.shipping.telefono.required &&
              !$parent.inputs.shipping.telefono.value
                ? 'border-danger'
                : ''
            "
          />
        </div>
        <div class="col-12 mt-3">
          <label
            :class="
              showRequired &&
              $parent.inputs.shipping.referencias.required &&
              !$parent.inputs.shipping.referencias.value
                ? 'text-danger'
                : ''
            "
            >Referencias</label
          >
          <input
            type="text"
            class="form-control shadow-sm"
            v-model="$parent.inputs.shipping.referencias.value"
            :class="
              showRequired &&
              $parent.inputs.shipping.referencias.required &&
              !$parent.inputs.shipping.referencias.value
                ? 'border-danger'
                : ''
            "
          />
        </div>
      </form>
    </div>
    <div class="d-flex justify-content-between">
      <span class="btn btn-secondary mt-4" @click="handleBackSteep"
        >Volver</span
      >
      <span class="btn btn-success mt-4" @click="handleNextSteep"
        >Continuar</span
      >
    </div>
  </div>
</template>


<script>
import countries from "../../configs/countries.js";
import MEX from "../../configs/cities/MEX.json";
export default {
  name: "SetShippingInfo",
  props: {},
  data() {
    return {
      items: [],
      paises: [],
      estadosMEX: [],
      showRequired: false,
      metodoEnvio: {
        id: 0,
        name: "",
        countries: [],
      },
    };
  },
  methods: {
    handleBackSteep() {
      this.$parent.backSteep();
    },
    handleNextSteep() {
      this.showRequired = true;
      if (
        !Object.keys(this.$parent.inputs.shipping).find(
          (x) =>
            this.$parent.inputs.shipping[x].required &&
            !this.$parent.inputs.shipping[x].value
        )
      ) {
        this.$parent.nextSteep();
      }
    },
    handleAutocomplete(){
      this.$parent.autoCompleteForms()
    }
  },
  created: function () {
    this.paises = countries;
    this.estadosMEX = MEX;
    this.items = this.$parent.cartItems;
    if (this.items.length) {
      // Buscamos el metodo de envio mas generico
      const metodo = this.items[0];

      const listCountries = metodo.sellerPlaces.map((e) =>
        countries.find((f) => f.iso3 == e)
          ? countries.find((f) => f.iso3 == e).nombre
          : ""
      );

      const buyerCountry = countries.find(
        (e) => e.iso3 == this.$parent.auth.pais
      );
      this.metodoEnvio = {
        id: metodo.shippingType,
        name:
          metodo.shippingType == 0
            ? "manual"
            : metodo.shippingType == 1
            ? "Guia prepagada de Sistema Apple"
            : "Recoger en domicilio",
        price: Number(metodo.shippingPrice),
        countries: listCountries,
        countryIncludeBuyer: buyerCountry,
      };
    }
  },
};
</script>